import React, { useState, useEffect } from 'react';
import '../App.css';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import MyLoader from './util/loader';
import MyStorage from './util/storage';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

const Equipment = () => { 
    //   const [filter, setFilter] = useState(Strings.doorCats[0]);
    var history = useHistory()
    const [models, setModels] = useState([]);
    const [loader, setLoader] = useState(false);
    const [list, setList] = useState([]);

    // load data
    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setLoader(true)
        Api.getEquipmentNeeds(
            (response) => {
                setLoader(false)
                setModels(response)
                let list = [];
                for (let i = 0; i < response.length; i++) {
                    const item = response[i];
                    list.push(item.title);
                }
                setList(list);
            },
            (error) => {
                setLoader(false)
            });
    };

    const getEqPhoto = (model) => {
        if (MyStorage.getFileUrls() == null || model.image == null || model.image === '') {
            return ''
        }
        else {
            return model.image
        }
    };

    const deleteEquipment = (eq) => {
        if (window.confirm('Are you sure you wish to delete this equipment?')) {
            setLoader(true)
            Api.deleteEquipmentNeeds(eq.id,
                (response) => {
                    setLoader(false)
                    if (response.status === 'success') {
                        showToast('success', 'Equipment deleted!')
                        loadData()
                    }
                },
                (error) => {
                    setLoader(false)
                    showToast('error', 'Request failed!')
                });
        }
    };

    const SortableItem = SortableElement(({ value }) => <div style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#F2F2F2', padding: 5, borderRadius: 5, fontSize: 14 }}>{value}</div>);

    const SortableList = SortableContainer(({ items }) => {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 10 }}>
                {items.map((value, index) => (
                    <SortableItem key={`item-${value}`} index={index} value={value} />
                ))}
            </div>
        );
    });

    const onSortEnd = ({ oldIndex, newIndex }) => {
        let tempList = arrayMoveImmutable(list, oldIndex, newIndex);
        console.log('New List: ' + JSON.stringify(tempList));
        setList(tempList);
        // update on server - loop through list and set order i+1
        let models = []
        for (let i = 0; i < tempList.length; i++) {
            const title = tempList[i];
            models.push({
                title: title,
                sortOrder: i+1
            })
        }
        console.log('models: '+JSON.stringify(models));
        Api.sortEquipment(JSON.stringify(models),
            (response) => {
                console.log('sort: '+JSON.stringify(response));
                loadData()
            },
            (error) => {
                //
            });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Equipment
                </div>
            </div>
            <div style={{ marginTop: 15 }}>
                <Button
                    className='btn-block btn-submit'
                    style={{ width: 150, borderWidth: 0, marginTop: 10, fontSize: 16 }}
                    onClick={() => {
                        console.log('click');
                        history.push({
                            pathname: '/add-equipment',
                            state: { model: null }
                        })
                    }}>
                    Add Equipment
                </Button>
                <div style={{ marginTop: 10 }}></div>
                
                <div style={{ marginTop: 20 }}>
                    Sorting (Drag the below items to change their order)
                </div>
                <SortableList
                    items={list}
                    onSortEnd={onSortEnd}
                    axis='xy' />

                {models.map((model, index) => {
                    let className = index % 2 !== 0 ? 'projects-itembar' : 'projects-itembar-colored'
                    return (
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                            onClick={() => {
                                console.log('click');
                            }}>
                            <div className={className} style={{ marginTop: 0 }}>
                                <div className='projects-item-photo'>
                                    <img src={getEqPhoto(model)} style={{ padding: 1, width: 140, height: 70, objectFit: 'cover' }} />
                                </div>
                                <div className='projects-item-cat' style={{}}>
                                    <div style={{ fontSize: 16 }}>{model.title}</div>
                                </div>
                                <div className='projects-item-cat' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        className='btn-block btn-submit'
                                        style={{ width: 100, backgroundColor: 'blue', borderWidth: 0, fontSize: 16 }}
                                        onClick={() => {
                                            console.log('click');
                                            history.push({
                                                pathname: '/add-equipment',
                                                state: { model: model }
                                            })
                                        }}>
                                        Edit
                                    </Button>
                                    <Button
                                        className='btn-block btn-submit'
                                        style={{ width: 100, backgroundColor: 'red', borderWidth: 0, marginLeft: 10, fontSize: 16 }}
                                        onClick={() => {
                                            console.log('click');
                                            deleteEquipment(model)
                                        }}>
                                        Delete
                                    </Button>
                                </div>
                            </div>

                        </div>
                    );
                })}
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default Equipment;